<script lang="ts">
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
	//Helpers
	import { hasVirtualGroups, isPillSerialMode } from 'src/helpers/thepill/thepill_data_helpers';
	//Components
	import ThumbLayerChart from '../Chart/LayerChart/ThumbLayerChart.svelte';
	import NoPeripheralsGuide from './NoPeripheralsGuide.svelte';
	import PillDrawerPeripherals from './PillDrawerPeripherals.svelte';
	import PillDrawerControl from './PillDrawerControl.svelte';
	import VGroupComponents from '../DevicesSettings/VirtualComponents/Components/VGroupComponents.svelte';
	import PillDrawerMainStatus from './PillDrawerMainStatus.svelte';

	export let device: Device,
		statuses,
		status: DeviceStatusG2,
		settings: DeviceSettingsG2 & { pill?: any },
		deviceChartsConfig: any[],
		handleOnClickThumbChart: (e: CustomEvent | Event) => void;

	const dispatch = createEventDispatcher();

	$: pillMode = settings?.pill?.mode || null;
	$: outputs = statuses.filter((i) => i.peripheralType === 'switch') || [];
	$: sensors = statuses.filter(
		(i) => i.peripheralType !== 'switch' && i.peripheralType !== 'humidity',
	);

	$: mainLabel = statuses.find((i) => i?.drawer_main);

	$: showGuide =
		(!statuses?.length && !showVirtualGroups) ||
		(mainLabel?.value && mainLabel?.value.includes('N/A'));
	$: showChart = deviceChartsConfig.length && (sensors.length < 2 || !outputs.length);

	$: showVirtualGroups = isPillSerialMode(pillMode) && hasVirtualGroups(settings);
</script>

<div class="flex-full-height justify-content-end">
	{#if showGuide}
		<NoPeripheralsGuide mode={pillMode} {device} {status} {settings} />
	{/if}

	{#if showVirtualGroups}
		<VGroupComponents {device} />
	{/if}

	<!-- Secondary Peripherals: Add-on peripherals -->
	<PillDrawerPeripherals on:click={(e) => dispatch('click', e.detail)} {sensors} />

	{#if mainLabel}
		<!-- Sensor Chart -->
		{#if showChart}
			<ThumbLayerChart
				class="mb-s"
				{device}
				{deviceChartsConfig}
				legacyStyle
				on:click={handleOnClickThumbChart}
			/>
		{/if}

		<!-- Main Label / Big Value Peripheral -->
		<PillDrawerMainStatus {pillMode} {statuses} {mainLabel} />
	{/if}
	<!-- Switch Outputs -->
	{#if outputs.length}
		<PillDrawerControl {device} {status} {outputs} />
	{/if}
</div>
